import {
  DefaultStackScreenOptions,
  LoginScreenPath,
} from "@/constants/Navigation";
import { Stack } from "@/crossPlatform/expo-router";

const Layout = () => {
  return (
    <Stack>
      <Stack.Screen
        name={LoginScreenPath.Login}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={LoginScreenPath.LoginAlias}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={LoginScreenPath.ForgotPassword}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={LoginScreenPath.MFA}
        options={DefaultStackScreenOptions}
      />
    </Stack>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- Layout file is used by expo-router file based navigation but TypeScript can not infer its usage
export default Layout;
